export default "__VITE_ASSET__C2jbUNT4__"